export const container = "dark:bg-gray-700 items-center justify-center min-h-screen p-4 border-b border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-600";
export const unactive = "dark:border-gray-600 flex items-center justify-between w-full p-5 font-medium text-left border-b border-gray-900";
export const active = "bg-gray-100 dark:bg-gray-800";
export const svg = "-3 h-3 rotate-180 transform transition-transform duration-300";
export const border = "border rounded-xl overflow-hidden border-green-500";
export const desplegable = "p-5 border-t border-gray-200 dark:border-green-500";
export const P = "mb-3 text-gray-500 dark:text-gray-400";
export const ol = "list-decimal pl-5 text-gray-500 dark:text-gray-400";
